module.exports = __webpack_public_path__ + "media/images/landing_page/stars-w-ss-1992705e8bb89c9a41b27b95c73d182d.png";